import Moment from "moment";
import $ from 'jquery';

export default class Helper {
	static autoFormatSize(sizeInKB) {
		const KB = sizeInKB;
		const MB = KB / 1000;
		const GB = MB / 1000;
		const TB = GB / 1000;

		if (TB >= 1) return TB.toFixed(2) + ' TB';
		if (GB >= 1) return GB.toFixed(2) + ' GB';
		if (MB >= 1) return MB.toFixed(2) + ' MB';
		return KB.toFixed(2) + ' KB';
	}

	static closeKeyboardBtn(id) {
		let closeBtn = document.getElementById(id);
		document.addEventListener("keypress", (event) => {
			let keyCode = event.keyCode ? event.keyCode : event.which;

			if (keyCode === 27) {
				closeBtn.click();
			}
		});
	}

	static changeLabelWorkLayer(value) {
		switch (value) {
			case "R01":
				return "R01 Pavement";
			case "R02":
				return "R02 Road Shoulder";
			case "R03":
				return "R03 Grass Cutting";
			case "R04":
				return "R04 Road Furniture";
			case "R05":
				return "R05 Bridges, Pedestrian Crossing & Culverts";
			case "R06":
				return "R06 Road Line Marking";
			case "R07":
				return "R07 Drainage";
			case "R08":
				return "R08 Road Cleaning";
			case "R09":
				return "R09 Routine Inspection";
			case "R10":
				return "R10 Mandatory Inspection";
			case "KKE":
				return "Electric";
			case "All":
				return "All";
		}
	}
	// Map a road.type enum value to a Jalan-Type filter bucket.
	// protocol/secondary/primary/minor map 1:1; everything else (bandaran,
	// perumahan_kos_murah, missing road) falls into "other".
	static jalanTypeBucket(roadType) {
		switch (roadType) {
			case "protocol": return "protocol";
			case "secondary": return "secondary";
			case "primary": return "primary";
			case "minor": return "minor";
			default: return "other";
		}
	}
	// Great-circle distance between two lat/lng points, in meters.
	static distanceMeters(lat1, lng1, lat2, lng2) {
		const R = 6371000;
		const toRad = (deg) => (deg * Math.PI) / 180;
		const dLat = toRad(lat2 - lat1);
		const dLng = toRad(lng2 - lng1);
		const a =
			Math.sin(dLat / 2) * Math.sin(dLat / 2) +
			Math.cos(toRad(lat1)) *
				Math.cos(toRad(lat2)) *
				Math.sin(dLng / 2) *
				Math.sin(dLng / 2);
		const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
		return R * c;
	}
	// Flatten a LineString/MultiLineString geometry into a flat list of
	// [lng, lat] vertex pairs (drops any 3rd altitude element per point).
	static flattenLineCoordinates(geometry) {
		if (!geometry) return [];
		if (geometry.type === "LineString") return geometry.coordinates;
		if (geometry.type === "MultiLineString") return geometry.coordinates.flat();
		return [];
	}
	// Split every MultiLineString feature into one LineString feature per
	// sub-path (same properties on each). A MultiLineString can bundle many
	// physically disconnected sub-paths under one name/feature — treating
	// that as a single hover/click unit highlights the whole bundle instead
	// of the specific segment under the cursor. Splitting first means each
	// sub-path gets its own generateId-assigned id, so feature-state hover
	// operates at sub-path granularity.
	//
	// Handles two input shapes, both seen live in Maintenance_Coverage
	// files: a FeatureCollection (geojson.features is an array), and a bare
	// single Feature at the top level (no features array at all — confirmed
	// against "Kuala Selangor - Jalan Sekunder.geojson", which is one
	// Feature with a 339-sub-path MultiLineString covering every secondary
	// road in that district). Always returns a FeatureCollection.
	static explodeMultiLineStrings(geojson) {
		if (!geojson) return geojson;

		const inputFeatures = Array.isArray(geojson.features)
			? geojson.features
			: geojson.type === "Feature"
			? [geojson]
			: [];

		if (!inputFeatures.length) return geojson;

		const features = [];
		inputFeatures.forEach((feature) => {
			if (feature.geometry && feature.geometry.type === "MultiLineString") {
				feature.geometry.coordinates.forEach((lineCoordinates) => {
					features.push({
						...feature,
						geometry: { type: "LineString", coordinates: lineCoordinates },
					});
				});
			} else {
				features.push(feature);
			}
		});

		return { type: "FeatureCollection", features };
	}
	static showTooltip(e) {
		if (e && e.target) {
			$(e.target).tooltip('show');
		}

		return;
	}
	static hideTooltip(e) {
		if (e && e.target) {
			$(e.target).tooltip('hide');
		}

		return;
	}

	static workCategories() {
		return ["Rutin", "Berkala_Pavemen", "Berkala_Bukan_Pavemen", "Kecemasan", "Agensi_Berkenaan"];
	}

	// Display labels for mix types. "hotmix" is REWORDED to "1x1m" per request —
	// the stored value stays "hotmix" so existing records remain valid.
	static mixTypeLabel(value) {
		const labels = {
			hotmix: "1x1m",
			coldmix: "COLDMIX",
			heavy_patching: "Heavy Patching",
		};

		return labels[value] || (value ? value.toUpperCase() : value);
	}

	static formatGeojsonName(name) {
		if (name) {
			let newName = name.replace(".geojson", "");

			return newName.split("_").join(" ");
		} else {
			return "";
		}
	}

	static colors(value) {
		const clr = {
			aqua: "#00ffff",
			beige: "#f5f5dc",
			brown: "#a52a2a",
			darkblue: "#00008b",
			darkcyan: "#008b8b",
			darkgreen: "#006400",
			darkkhaki: "#bdb76b",
			darkmagenta: "#8b008b",
			darkorange: "#ff8c00",
			darkred: "#8b0000",
			darksalmon: "#e9967a",
			darkviolet: "#9400d3",
			fuchsia: "#ff00ff",
			gold: "#ffd700",
			green: "#008000",
			indigo: "#4b0082",
			khaki: "#f0e68c",
			lightblue: "#add8e6",
			lightcyan: "#e0ffff",
			lightgreen: "#90ee90",
			lightgrey: "#d3d3d3",
			lightpink: "#ffb6c1",
			lightyellow: "#ffffe0",
			lime: "#00ff00",
			magenta: "#ff00ff",
			maroon: "#800000",
			navy: "#000080",
			olive: "#808000",
			orange: "#ffa500",
			darkorchid: "#9932cc",
			pink: "#ffc0cb",
			cyan: "#00ffff",
			darkolivegreen: "#556b2f",
			purple: "#800080",
			violet: "#800080",
			darkgrey: "#a9a9a9",
			red: "#ff0000",
			silver: "#c0c0c0",
			white: "#ffffff",
			yellow: "#ffff00",
			blue: "#0000ff",
			azure: "#f0ffff"
		}

		const name = value < Object.keys(clr).length ? Object.keys(clr)[value] : Object.keys(clr)[value - Object.keys(clr).length];

		return clr[name];
	}

	static titleCase(text) {
		return text.replace(/([a-z])([A-Z])/g, '$1 $2');
	}

	static snakeToTitleCase(text) {
		let result = text.split("_");

		result = result.map(t => t[0].toUpperCase().concat(t.substring(1, t.length))).join(" ");

		return result;
	}

	static generateCaseNumber(id) {
		let retVal = id.replace(/\D/g, '');
		return retVal.substring(retVal.length - 6);
	}

	static formatDate(date, noTime) {
		if (!date) {
			return "";
		} else {
			let format = noTime ? "D MMM YYYY" : "D MMM YYYY, h:mm A"
			return !Number.isNaN(date) && (date.toString().length == 10 || date.toString().length == 13) ? Moment.unix(parseInt(date)).format(format) : Moment(date).format(format);
		}
	}

	static formatMediaUrl(media) {
		if (!media) return false;

		// New format: media is already a URL string
		if (typeof media === 'string') {
			return media.startsWith('http') ? media : false;
		}

		// Old format: Strapi upload object with .url
		if (media.url) {
			let url = media.url;
			return url.startsWith("http") ? url : `https://${url}`;
		}

		return false;
	}

	static formatCoordinate(coord) {
		if (coord && coord.length == 2) {
			return `${parseFloat(coord[0]).toFixed(6)}, ${parseFloat(coord[1]).toFixed(6)}`;
		} else if (coord && coord.length == 1) {
			return `${parseFloat(coord[0]).toFixed(6)}`;
		} else {
			return "";
		}
	}

	static getRoadInfo(road, breakLine) {
		if (!road) {
			return "";
		}

		let result = [];

		if (road.name) {
			result.push(road.name);
		}

		if (road.subdistrict) {
			result.push(road.subdistrict);
		}

		if (road.district) {
			result.push(road.district);
		}

		return result.join(breakLine ? "<br />" : ", ");
	}

	static socialMediaIcons(type) {
		const icons = {
			facebook: {
				i: ["fab", "facebook-square"],
				color: "facebook"
			},
			twitter: {
				i: ["fab", "twitter"],
				color: "twitter"
			},
			waze: {
				i: ["fab", "waze"],
				color: "waze"
			},
			instagram: {
				i: ["fab", "instagram"],
				color: "instagram"
			},
			mobile: {
				i: ["fas", "mobile-alt"],
				color: "dark"
			},
			ai: {
				i: ["fas", "video"],
				color: "dark"
			},
			textMessage: {
				i: ["far", "comment-dots"],
				color: "info"
			},
			others: {
				i: ["fas", "comment-alt"],
				color: "light"
			}
		}

		const result = icons[type];

		return result ? result : icons.others;
	}

	// Pure predicate: does a defect marker layer match the current status +
	// report-type filters? Mirrors the legacy caseByStatus/reportTypeCase watcher
	// logic exactly. layerId format: circle-<status>-<reportType>-<caseId>.
	// closedBucket is closedBucketMap[caseByStatus] ("within24h"|"over24h"|"anomaly"|undefined);
	// closedClassForId is closedClassById[caseId].
	static matchesStatusReport(layerId, caseByStatus, reportTypeCase, closedBucket, closedClassForId) {
		if (closedBucket) {
			const matchClass = closedClassForId === closedBucket;
			const matchReport =
				reportTypeCase === "All" || layerId.includes(`-${reportTypeCase}-`);
			return matchClass && matchReport;
		}
		let status = "";
		if (caseByStatus === "Closed Case") status = "closed";
		else if (caseByStatus === "Open Case") status = "open";
		else if (caseByStatus === "NOE") status = "noe";
		else if (caseByStatus === "Tampalan PBT") status = "tampalan_pbt";
		if (caseByStatus !== "All") {
			return layerId.includes(
				`circle-${status}${reportTypeCase !== "All" ? `-${reportTypeCase}` : ``}`
			);
		}
		return layerId.includes(`${reportTypeCase !== "All" ? `${reportTypeCase}` : ``}`);
	}

	static colorPalettes = [
		"#ecdd7b",
		"#8f3bb3",
		"#bfdbf7",
		"#9d858d",
		"#776871",
		"#5c7457",
		"#eee1b3",
		"#dbad6a",
		"#cf995f",
		"#d0ce7c",
		"#b09e99",
		"#fee9e1",
		"#fad4c0",
		"#64b6ac",
		"#c0fdfb",
		"#5efc8d",
		"#8ef9f3",
		"#4c5760",
		"#01fdf6",
		"#03fcba"
	]

	// Build the District × Work-Layer matrix rows. All districts are listed;
	// unassigned ones are locked (assigned:false). Default active = assigned
	// (mirror today). work/maintenance availability is filled in later from KML.
	// Admin users (no assigned districts) get every district assigned+active.
	static buildDistrictMatrix(allDistricts, userDistricts) {
		const isAdmin = !userDistricts || userDistricts.length === 0;
		const assignedIds = new Set((userDistricts || []).map((d) => String(d._id)));
		return allDistricts.map((d) => {
			const assigned = isAdmin || assignedIds.has(String(d._id));
			return {
				id: String(d._id),
				name: d.name,
				assigned,
				active: assigned,
				work: {},
				maintenance: {},
			};
		});
	}
}
